<template>
  <div :class="classField">
    <label class="label">
      {{ name }}
      <span v-if="typeof required !== 'undefined'" class="has-text-danger">*</span>
      <span v-if="addTitle" class="is-size-7">{{ addTitle }}</span>
    </label>
    <div class="control" :class="{'is-flex': $slots.default}">
      <multiselect
        class="custom-select"

        :modelValue="modelValue"
        @update:modelValue="event => $emit('update:modelValue', event)"
        :options="filteredOptions"
        :placeholder="name"
        :required="required"
        :disabled="disabled"
        :id="id"
        :track-by="trackBy"
        :label="label"
        :custom-label="customLabel"
        :allowEmpty="allowEmpty"
        :loading="loading"
        :multiple="multiple"

        @select="event => $emit('select', event)"
        @remove="event => $emit('remove', event)"
        :internal-search="false"
        @search-change="onSearchChange"
      >
        <template #noResult>
          <span>Nessun risultato</span>
        </template>
        <template #noOptions>
          <span>Nessun risultato</span>
        </template>

        <template #clear>
          <div class="custom-clear" v-if="allowEmpty && modelValue && !multiple" @mousedown.prevent="clear()" ><font-awesome-icon icon="times" /></div>
        </template>

        <template #option="props">
          <slot name="option" :option="props.option"></slot>
        </template>
        <template #singleLabel="props">
          <slot name="singleLabel" :option="props.option"></slot>
        </template>
      </multiselect>
      <slot></slot>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [Object, String],
      default: null
    },
    required: {
      type: Boolean,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: []
    },
    id: {
      type: String,
      default: null
    },
    trackBy: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    customLabel: {
      type: Function,
      default (option, label) {
        if (!option || (Array.isArray(option) && option.length === 0)) return ''
        return label ? option[label] : option
      }
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    classField: {
      type: String,
      default: 'field'
    },
    addTitle: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue', 'select', 'remove', 'search-change'],

  data() {
    return {
      searchString: ''
    }
  },

  computed: {
    filteredOptions() {
      return this.options.filter(record => {
        let result = true

        if (record) {
          const label = this.customLabel(record, this.label)?.toLowerCase()

          this.searchString.split(' ').forEach(word => {
            if (!label?.includes(word.toLowerCase())) {
              result = false
            }
          })
        }

        return result
      })
    }
  },

  methods: {
    clear() {
      this.$emit('update:modelValue', null)
      this.$emit('select', null)
    },

    onSearchChange(text) {
      this.searchString = text
      this.$emit('search-change', text)
    },

    customSearch(props) {
      console.log(props)
    }
  }
}
</script>

<style lang="scss">
/* Custom vue select */
.custom-select {
  .custom-clear {
    position: absolute;
    right: 32px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    width: 20px;
  }

  .multiselect__select {
    padding-left: 0;
    width: 32px;
  }

  .multiselect__tags {
    padding: 8px 60px 0 8px;
  }
}
</style>